import { RootState } from '../rootReducer';

// Account selectors
export const selectAccountState = (state: RootState) => state.accounts;

export const selectAccount = (state: RootState) => state.accounts.account;

export const selectAccountLoading = (state: RootState) =>
  state.accounts.loading;

export const selectAccountError = (state: RootState) => state.accounts.error;

export const selectInviteUserLoading = (state: RootState) =>
  state.accounts.inviteUserLoading;

export const selectInviteUserError = (state: RootState) =>
  state.accounts.inviteUserError;

export const selectInviteUserSuccess = (state: RootState) =>
  state.accounts.inviteUserSuccess;

export const selectDeleteUserLoading = (state: RootState) =>
  state.accounts.deleteUserLoading;

export const selectDeleteUserError = (state: RootState) =>
  state.accounts.deleteUserError;

export const selectDeleteUserSuccess = (state: RootState) =>
  state.accounts.deleteUserSuccess;

export const selectUpdateUserLoading = (state: RootState) =>
  state.accounts.updateUserLoading;

export const selectUpdateUserError = (state: RootState) =>
  state.accounts.updateUserError;

export const selectUpdateUserSuccess = (state: RootState) =>
  state.accounts.updateUserSuccess;
